import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import HelpCenterCategorySections from '@/components/help-center-category-sections';
import type { HelpCenterCategory } from '@/lib/api/help-center.server';

export interface GiftCardPdpFaqsProps {
    category: HelpCenterCategory;
    noSectionNames?: boolean;
}

export function GiftCardPdpFaqsFallback(): ReactElement {
    return (
        <section className="bg-neutral-white" aria-hidden data-testid="gift-card-pdp-faqs-fallback">
            <div className="grid-global py-2 lg:py-20">
                <div className="hidden h-8 w-48 rounded bg-neutral-90 lg:col-start-2 lg:col-span-2 lg:block" />
                <div className="col-span-6 flex flex-col lg:col-start-5 lg:col-span-7">
                    <div className="h-16 border-b border-neutral-80" />
                    <div className="h-16 border-b border-neutral-80" />
                    <div className="h-16 border-b border-neutral-80" />
                </div>
            </div>
        </section>
    );
}

export default function GiftCardPdpFaqs({ category, noSectionNames = false }: GiftCardPdpFaqsProps): ReactElement {
    const { t } = useTranslation('product');

    return (
        <section className="bg-neutral-white" data-component="gift-card-pdp-faqs" data-testid="gift-card-pdp-faqs">
            <div className="grid-global py-2 lg:py-20">
                <h2 className="heading-headline-m hidden lg:col-start-2 lg:col-span-2 lg:block">{t('faqTitle')}</h2>
                <HelpCenterCategorySections
                    category={category}
                    noSectionNames={noSectionNames}
                    className="col-span-6 lg:col-start-5 lg:col-span-7"
                />
            </div>
        </section>
    );
}
